import { DataTool } from './DataTool'
import { P2P_DATA_COLLECTION_INSTRUCTIONS_URL } from '../../../constants/gvsuLinks'

interface Props {
  planOrganizationTaskId: number
  completed: boolean
  dueDate: Date
}
export const PeerToPeerDataCollectionSystemTool = (props: Props): JSX.Element => {
  return (
    <DataTool
      planOrganizationTaskId={props.planOrganizationTaskId}
      completed={props.completed}
      title='Peer to Peer Data Collection System'
      dueDate={props.dueDate}
      instructionsUrl={P2P_DATA_COLLECTION_INSTRUCTIONS_URL}
      color='var(--light-blue-700)'
      successMessage='Peer to Peer Data Collection System Updated'
      dataTestId='peerToPeerDataCollectionSystemTool'
    />
  )
}
